<template>
    <div id="app">
        <router-view name="blank"></router-view>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
    }
</script>
 
<style lang="less">
    #app {
        font-size: 12px;
        background-color: #222d32;
    }

</style>
<style>


    /* add by wenhe at 2019.12.11 , remark 修复表格 错位, 本来想着用js修复,搞了一晚上 , 木搞好, 度娘给了两行样式代码 , 结果就好了 , 度娘威武 */
    body .el-table th.gutter {
        display: table-cell !important;
    }

    body .el-table colgroup.gutter {
        display: table-cell !important;
    }

</style>



// WEBPACK FOOTER //
// App.vue?6e8dbf81